import styled from 'styled-components';
import Select from 'react-select';

interface SelectorProps {
    width?: string;
    menuHeight?: number;
    onChange?: any;
}

// TODO: SIP. В рамках рефакторинга понять, оставляем ли этот компонент или нет.
export const SelectView = styled(Select)<SelectorProps>`
    line-height: 24px;
    width: 100%;
    border-radius: 44px;
    display: inline-block;
    border: none;
    background: #2f2f2f;
    padding: 0 5px 0 5px;
    cursor: pointer;
    color: white;
    font-weight: normal;
    font-size: 14px;
    white-space: nowrap;

    .react-select__control {
        width: 100%;
        overflow: hidden;
        border-radius: 44px;
        border: none;
        cursor: pointer;
        box-shadow: none;
        display: flex;
        align-items: center;
        box-sizing: border-box;
    }

    .react-selector__indicators .react-selector__indicator-separator {
        display: none;
    }

    .react-selector__indicators {
        display: flex;

        span {
            display: flex;
        }
    }

    .react-selector__menu {
        margin: 0;
        width: 200px;
        border-radius: 12px;
        box-sizing: border-box;
        overflow: hidden;
        background: #2f2f2f;
        display: flex;
        flex-direction: column;

        &-list {
            padding: 0;
        }

        .react-selector__option {
            padding: 10px 16px;
            cursor: pointer;
            display: flex;
            align-items: center;

            &--is-selected {
                background: rgba(255, 255, 255, 0.1);
            }

            &--is-focused {
                background: grey;
            }
        }
    }

    .react-selector__single-value,
    .react-selector__input {
        margin: 0;
        background: #2f2f2f;
    }

    .react-selector__dropdown-indicator {
        padding: 10px;
    }

    .react-selector__control {
        background: #2f2f2f;
        border-color: #2f2f2f;
        border-radius: 44px;

        &:hover {
            border-color: #2f2f2f;
            box-shadow: #434343;
        }

        &--menu-is-open {
            border-color: #2f2f2f;
        }
    }

    .react-selector__single-value {
        color: white;
    }

    .react-selector__option:hover,
    .react-selector__option--is-selected {
        color: white;
    }
`;
